/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { string, func, node, bool } from 'prop-types';
import classNames from 'clsx';
import { NavLink } from 'react-router-dom';

import Spinner from 'components/Spinner/Spinner';

import styles from './button.scss';

/**
 * This is the Button component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export default class Button extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {Object}
   */
  static propTypes = {
    path: string,
    onClick: func,
    wide: bool,
    micro: bool,
    small: bool,
    white: bool,
    grey: bool,
    dark: bool,
    warning: bool,
    sending: bool,
    disabled: bool,
    active: bool,
    icon: bool,
    className: string,
    ghost: bool,
    text: bool,
    borderless: bool,
    children: node.isRequired,
  };

  static defaultProps = {
    onClick: () => {},
    path: null,
    url: null,
    className: null,
    wide: false,
    micro: false,
    small: false,
    white: false,
    grey: false,
    dark: false,
    warning: false,
    sending: false,
    active: false,
    ghost: false,
    icon: false,
    borderless: false,
    text: false,
    disabled: false,
  };

  /**
   * Render Button.
   *
   * @return {JSX}
   */
  render() {
    const {
      children,
      path,
      onClick,
      wide,
      micro,
      small,
      grey,
      white,
      dark,
      warning,
      ghost,
      sending,
      disabled,
      active,
      icon,
      borderless,
      text,
      className: customClassName,
    } = this.props;

    const isExternal = /^https?:\/\//.test(path);

    const className = classNames(styles.button, customClassName, {
      [styles.ghost]: ghost,
      [styles.wide]: wide,
      [styles.micro]: micro,
      [styles.small]: small,
      [styles.white]: white,
      [styles.grey]: grey,
      [styles.dark]: dark,
      [styles.warning]: warning,
      [styles.sending]: sending,
      [styles.disabled]: disabled,
      [styles.active]: active,
      [styles.icon]: icon,
      [styles.borderless]: borderless,
      [styles.text]: text,
    });

    if (isExternal) {
      return (
        <a
          href={path}
          className={className}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      );
    }

    if (path) {
      return (
        <NavLink to={path} className={className}>
          {children}
        </NavLink>
      );
    }

    return (
      <button onClick={onClick} className={className}>
        <span className={styles.text}>{children}</span>
        {sending && (
          <span className={styles.spinner}>
            <Spinner medium />
          </span>
        )}
      </button>
    );
  }
}
